import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/balances": [5],
		"/dashboard": [6],
		"/explorer": [7],
		"/explorer/channels": [8],
		"/explorer/clients": [9],
		"/explorer/connections": [10],
		"/explorer/find-packet": [11],
		"/explorer/packets": [12],
		"/explorer/packets/incomplete": [14],
		"/explorer/packets/[packet_hash]": [13,[2]],
		"/explorer/tokens": [15],
		"/explorer/transfers": [16],
		"/explorer/transfers/[packet_hash]": [17,[3]],
		"/faucet": [18],
		"/health": [19],
		"/nodes": [20],
		"/stake": [21],
		"/transfers": [26],
		"/transfer": [22],
		"/transfer/multisig": [23],
		"/transfer/native": [24],
		"/transfer/ts-packets": [25]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';